import microphone from "../../assets/ui/nav/microphone.svg";
import { VoiceReadiness } from "./VoiceReadiness";

export type EditorVoiceMode = "idle" | "starting" | "listening" | "processing" | "error";

/** The shared voice control used by food and list editors. */
export function EditorVoiceAction({ mode, label, microphoneLabel = label, text, error, progressText, disabled = false, onMicrophone }: {
  mode: EditorVoiceMode; label: string; microphoneLabel?: string;
  text: string; error: string; progressText: string; disabled?: boolean; onMicrophone: () => void;
}) {
  const active = mode !== "idle";
  const recording = mode === "listening";
  return <div className={`meal-voice-action${active ? " is-expanded" : ""}`}>
    <button className={`mic-button meal-edit-voice${recording ? " is-listening" : ""}`} type="button" aria-label={recording ? "Закончить голосовую команду" : microphoneLabel} disabled={disabled || mode === "starting" || mode === "processing"} onClick={onMicrophone}><img src={microphone} alt="" /></button>
    {(mode === "starting" || recording) ? <VoiceReadiness ready={recording} /> : <span>{mode === "processing" ? "Применяю изменение…" : mode === "error" ? "Повторить команду" : label}</span>}
    {active && mode !== "starting" && <div className={`meal-inline-transcript${mode === "error" ? " is-error" : ""}`} aria-live="polite">{mode === "error" ? error : mode === "processing" ? progressText : text || "Говорите, я записываю…"}</div>}
  </div>;
}
